<template>
  <div class="home">
    <div class="mt-2 mb-2 p-2">
      <div class="row justify-content-center">
        <img alt="Vue logo" src="../assets/AIMS2GOlogo.png" style="width: 380px">
      </div>

      <div class="row justify-content-center my-5 mx-1">
        <div style="height:55vh; width:100%">
          <l-map ref="map" :zoom="zoom" :center="center" @ready="onMapReady()">

            <l-marker v-for="site in all_sites"
              :key="site.uuid"
              :lat-lng="[site.lat, site.long]"
            >
              <l-popup>
                <router-link :to="{ name: 'ShowSite', params: { id: site.uuid } }">
                  <strong class="d-block text-gray-dark mb-1">{{ site.name }}</strong>
                </router-link>                
              </l-popup>
            </l-marker>

            <l-tile-layer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              layer-type="base"
              name="OpenStreetMap"
            ></l-tile-layer>

          </l-map>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';

import "leaflet/dist/leaflet.css";
import { latLngBounds } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup, LLayerGroup } from "@vue-leaflet/vue-leaflet";

export default {
  name: 'Home',
  setup() {
    const store = useStore();
    const map = null;
    const zoom = ref(2);
    const center = ref([0,0]);

    // gathering all sites that has long and lat
    const all_sites = store.getters.allSites.filter(site => ((site.lat) && (site.long)));
    let bounds;

    if (all_sites.length == 1) {
      // if there is one site only, center the map on the site
      bounds = null;
      center.value = [all_sites[0].lat, all_sites[0].long];
      zoom.value = 15;
    } else if (all_sites.length > 1) {
      // otherwise create a bound, which can only be set once the map is ready
      const lat_lngs = all_sites.map(site => [site.lat, site.long]);
      console.log("Inside Home.vue, lat_lngs ==> ", lat_lngs);
      bounds = latLngBounds(lat_lngs);
      console.log("Inside Home.vue, bounds ==> ", bounds);
    }

    return {
      zoom: zoom,
      center: center,
      bounds,
      map,
      all_sites
    }
  },
  methods: {
    onMapReady() {
      if (this.bounds) {
        this.map = this.$refs.map.leafletObject;
        this.map.fitBounds(this.bounds);
      }
    }
  },
  components: {
    LMap,
    LTileLayer,
    LLayerGroup,
    LMarker,
    LPopup
  }
}
</script>
